export function calculateLastDate(leftDate: Date, areaColumnsCount: number): Date {
    const lastDate = new Date(leftDate.getTime());
    lastDate.setDate(lastDate.getDate() + areaColumnsCount - 1);

    return lastDate;
}